import { render, staticRenderFns } from "./DisabledOverlay.vue?vue&type=template&id=45309f4b&scoped=true&lang=html&"
import script from "./DisabledOverlay.vue?vue&type=script&lang=js&"
export * from "./DisabledOverlay.vue?vue&type=script&lang=js&"
import style0 from "./DisabledOverlay.vue?vue&type=style&index=0&id=45309f4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45309f4b",
  null
  
)

export default component.exports